import { CATEGORIES, type ISpecCategories } from '../../spec/SpecCategories';
import type { Field } from '../Field';
import { CategoryType } from './CategoryType';

/**
 * Class for managing FIX field categories.
 * Provides functionality to process and categorize FIX fields based on their specifications.
 */
export class Categories {
    /** Array of all available category specifications */
    public categories: ISpecCategories[] = CATEGORIES;
    /** Cache map for looking up categories by name */
    public cacheMap: Map<string, ISpecCategories> = new Map<string, ISpecCategories>();
    /** Instance of CategoryType for managing category data */
    public categoryType: CategoryType = new CategoryType();

    /**
     * Creates a new Categories instance and initializes the cache map
     * with all available category specifications.
     */
    constructor() {
        this.categories.forEach((category: ISpecCategories) => {
            this.cacheMap.set(category.name, category);
        });
    }

    /**
     * Processes a field's category based on its base category name.
     * Sets the appropriate category type for the field if found.
     *
     * @param {Field} field - The field to process
     * @param {string} baseCategory - The base category name to look up
     */
    public processCategory(field: Field, baseCategory: string): void {
        this.categoryType.reset();
        const categoryData: ISpecCategories | undefined = this.cacheMap.get(baseCategory);
        if (categoryData) {
            this.categoryType.setCategory(categoryData);
            field.setCategory(this.categoryType);
        }
    }
}
